module.exports = __webpack_public_path__ + "static/media/pricing@2x.bc64818d.mov";